import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-24 border-t border-[#e8e2da] bg-[#faf9f6]"
    >
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-4 lg:px-10">
        <div className="md:col-span-2">
          <div className="text-2xl font-serif font-semibold text-[#2a2928]">
            balloon<span className="text-[#d08c8c]">.</span>bites
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-[#7a7571]">
            Handcrafted stuffed balloon hampers and customised chocolates for
            the moments worth remembering. Delivered thoughtfully across India.{" "}
          </p>
        </div>

        <div>
          <p className="label-tiny mb-4">Shop</p>
          <ul className="space-y-2 text-sm text-[#2a2928]">
            <li><Link to="/shop" className="hover:text-[#d08c8c]">Balloon Hampers</Link></li>
            <li><Link to="/chocolates" className="hover:text-[#d08c8c]">Customised Chocolates</Link></li>
            <li><Link to="/shop?category=birthday" className="hover:text-[#d08c8c]">Birthday</Link></li>
            <li><Link to="/shop?category=anniversary" className="hover:text-[#d08c8c]">Anniversary</Link></li>
          </ul>
        </div>

        <div>
          <p className="label-tiny mb-4">Get in touch</p>
          <ul className="space-y-3 text-sm text-[#2a2928]">
            <li>
              <a
                href="mailto:balloonbiteshelps@gmail.com"
                data-testid="footer-email"
                className="flex items-center gap-2 hover:text-[#d08c8c]"
              >
                <Mail className="h-4 w-4 text-[#d08c8c]" /> balloonbiteshelps@gmail.com
              </a>
            </li>
            <li>
              <a
                href="https://wa.me/917899481956"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="flex items-center gap-2 hover:text-[#d08c8c]"
              >
                <Phone className="h-4 w-4 text-[#d08c8c]" /> +91 78994 81956
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/balloonbites/"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="flex items-center gap-2 hover:text-[#d08c8c]"
              >
                <Instagram className="h-4 w-4 text-[#d08c8c]" /> @balloonbites
              </a>
            </li>
            <li className="flex items-center gap-2 text-[#7a7571]">
              <MapPin className="h-4 w-4 text-[#d08c8c]" /> Studio · Hassan, Karnataka
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#e8e2da] py-6 text-center text-xs text-[#7a7571]">
        © {new Date().getFullYear()} BalloonBites. Crafted with care.
      </div>
    </footer>
  );
}
